import { useEffect } from 'react'

function useKeyDown(handleProfileAction: () => void) {
    useEffect(() => {
        const handleKeyDown = (event: globalThis.KeyboardEvent) => {
            if (event.key === 'Enter') {
                handleProfileAction()
            }
        }

        window.addEventListener('keypress', handleKeyDown)

        return () => {
            window.removeEventListener('keypress', handleKeyDown)
        }
    }, [handleProfileAction])
}

export default useKeyDown
